export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    description: '',
    qty: 1,
    unit_rate: 0,
    request_for_material_id: 0,
    external_number: '',
    sale_number: '',
    item_edit: 0
}

export let dataProps = {
    id: 0,
    vendor_id: null, 
    store_id: null,
    po_number: null,
    po_date: new Date(), 
    expected_delivery_date: new Date(), 
    home_currency_id: 0,
    billing_currency_id: null,
    exchange_rate: 0,
    shipment_address: '', 
    additional_notes: '', 
    status: 0, 
    
    generated_by_staff_id: 0,
    approved_by_staff_id: 0, 
    approval_notes: '', 
    approval_date: new Date(), 
    estimated_total_cost: 0,
    order_from_store_id: null,
    ordered_from: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryOrder/properties.js